import { planIntervals } from "@circle-react/helpers/plansHelpers";
import type { PlanIntervals } from "@circle-react/helpers/plansHelpers";
import type { Plan } from "@circle-react/types";

import { usePlans } from "../RegularPlan/PlansContext";
import { useFetchPlans } from "./usePlansApi";

interface UseAuxiliaryPlansResult {
  areBothIntervalsLoaded: boolean;
  auxiliaryBillingCycle: PlanIntervals | null;
  auxiliaryPlans: Plan[];
  auxiliarySelectedPlan?: Plan;
  monthlyPlan?: Plan;
  yearlyPlan?: Plan;
}

export const useAuxiliaryPlans = (): UseAuxiliaryPlansResult => {
  const {
    billingCycle,
    billingCurrency,
    selectedPlan,
    selectedPlanTier,
    plans: currentPlans,
    isPlansLoading: isCurrentPlansLoading,
  } = usePlans();

  const auxiliaryBillingCycle =
    billingCycle === planIntervals.month
      ? planIntervals.year
      : planIntervals.month;

  const { plans: auxiliaryPlans, isPlansLoading: isAuxiliaryPlansLoading } =
    useFetchPlans({
      billing_cycle: auxiliaryBillingCycle,
      billing_currency: billingCurrency,
      locale: null,
    });

  const auxiliarySelectedPlan = selectedPlanTier
    ? auxiliaryPlans.find(plan => plan.tier === selectedPlanTier)
    : undefined;

  const areBothIntervalsLoaded =
    !isCurrentPlansLoading &&
    !isAuxiliaryPlansLoading &&
    currentPlans.length > 0 &&
    auxiliaryPlans.length > 0;

  const yearlyPlan =
    billingCycle === planIntervals.year ? selectedPlan : auxiliarySelectedPlan;
  const monthlyPlan =
    billingCycle === planIntervals.month ? selectedPlan : auxiliarySelectedPlan;

  return {
    auxiliaryPlans,
    auxiliarySelectedPlan,
    areBothIntervalsLoaded,
    auxiliaryBillingCycle,
    monthlyPlan,
    yearlyPlan,
  };
};
